import $ from 'jquery';
import CancelablePromise from 'p-cancelable';

const RequestVerificationTokenHeaderName = 'RequestVerificationToken';

function getRequestVerificationToken() {
  const $input = document.querySelector('input[name="__RequestVerificationToken"]');

  if (!$input) {
    return undefined;
  }

  return $input.value;
}

function addTokenToHeaders(headers) {
  const token = getRequestVerificationToken();

  if (token) {
    // eslint-disable-next-line no-param-reassign
    headers[RequestVerificationTokenHeaderName] = token;
  }
}

function request(ajaxOptions) {
  let jqXHR;
  let requestAborted = false;

  const promise = new CancelablePromise((onCancel, resolve, reject) => {
    onCancel(() => {
      requestAborted = true;
      jqXHR.abort();
    });

    jqXHR = $.ajax(ajaxOptions)
      .done(resolve)
      .fail(() => {
        if (requestAborted) {
          return;
        }

        reject(jqXHR);
      });
  });

  return promise;
}

function post(url, data) {
  const options = {
    dataType: 'json', contentType: 'application/json', method: 'POST', headers: {}, url,
  };

  addTokenToHeaders(options.headers);

  if (data) {
    options.data = JSON.stringify(data);
  }

  return request(options);
}

function postWwwFormUrlEncoded(url, data = {}) {
  const options = {
    dataType: 'json', contentType: 'application/x-www-form-urlencoded', method: 'POST', headers: {}, url, data,
  };

  addTokenToHeaders(options.headers);

  return request(options);
}

function get(url, data = {}) {
  const options = {
    dataType: 'json', method: 'GET', url, data,
  };

  return request(options);
}

function put(url, data = {}) {
  const options = {
    dataType: 'json', method: 'PUT', headers: {}, url, data,
  };

  addTokenToHeaders(options.headers);

  return request(options);
}

function deleteRequest(url, data = {}) {
  const options = {
    dataType: 'json', method: 'DELETE', headers: {}, url, data,
  };

  addTokenToHeaders(options.headers);

  return request(options);
}

export default {
  post,
  postWwwFormUrlEncoded,
  get,
  put,
  delete: deleteRequest,
  getRequestVerificationToken,
};
